import { render, staticRenderFns } from "./information-form-candidate.vue?vue&type=template&id=58a36de3&scoped=true&"
import script from "./information-form-candidate.vue?vue&type=script&lang=js&"
export * from "./information-form-candidate.vue?vue&type=script&lang=js&"
import style0 from "./information-form-candidate.vue?vue&type=style&index=0&id=58a36de3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a36de3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a36de3')) {
      api.createRecord('58a36de3', component.options)
    } else {
      api.reload('58a36de3', component.options)
    }
    module.hot.accept("./information-form-candidate.vue?vue&type=template&id=58a36de3&scoped=true&", function () {
      api.rerender('58a36de3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/projects/information-form-candidate.vue"
export default component.exports